export const socialsData = {
    github: 'https://github.com/aliahad002',
    facebook: 'https://www.facebook.com/aliahad002',
    linkedIn: 'https://www.linkedin.com/in/Ahad-Abbasi',
    instagram: 'https://www.instagram.com/aliahad002',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/aliahad002',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://dev.to/aliahad002',
    medium: 'https://medium.com/@aliahad002',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}